@use "ui/styles/effects";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/colors";
@use "ui/styles/fonts";

.wrapper {
  display: flex;
  flex-direction: column;
  gap: sizes.$s4;
}

.toolbar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: sizes.$s6;

  .count {
    @include fontStyles.subtitle-medium;
    margin: 0;
  }

  .checkbox {
    margin-left: sizes.$s4;
  }

  .checkboxLabel {
    @include fontStyles.h6-book;
  }
}

.tree {
  display: flex;
  flex-direction: column;
  gap: sizes.$s4;
  padding-left: sizes.$s6;
}

.row {
  display: flex;
  align-items: center;
  padding-top: sizes.$s4;
  gap: 6px; /* chevron ↔ checkbox */
}

.chevron {
  width: 16px;
  height: 16px;
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  opacity: 0; /* reserve space for leaf nodes */
}

.children {
  margin-left: 22px;
  display: flex;
  flex-direction: column;
  gap: sizes.$s3;
}

.labelWrapper {
  display: flex;
  align-items: center;
  gap: sizes.$s4; /* icon ↔ label */
}

.labelIcon {
  @include fontStyles.h6-book;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding-left: sizes.$s2;

  svg {
    width: 1em;
    height: 1em;
  }
}

.labelIcon:empty {
  display: none;
}

.labelText {
  @include fontStyles.h6-book;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.subdued {
  @include fontStyles.subdued;
}
